import { bootstrapApplication } from '@angular/platform-browser';
import { ModuleRegistry as AgChartsModuleRegistry, AllCommunityModule as AllChartsCommunityModule } from 'ag-charts-community';
import { ModuleRegistry, ValidationModule } from 'ag-grid-community';
import { AllEnterpriseModule, LicenseManager } from 'ag-grid-enterprise';
import { Amplify } from 'aws-amplify';
import { signInWithRedirect } from 'aws-amplify/auth';
import { App } from './app/app';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

void signInWithRedirect;

Amplify.configure({
	Auth: {
		Cognito: {
			userPoolId: environment.UserAuth.aws_user_pools_id,
			userPoolClientId: environment.UserAuth.aws_user_pools_web_client_id,
			identityPoolId: environment.UserAuth.aws_cognito_identity_pool_id,
			loginWith: {
				oauth: {
					domain: environment.UserAuth.oauth.domain,
					scopes: environment.UserAuth.oauth.scope,
					redirectSignIn: [environment.UserAuth.oauth.redirectSignIn],
					redirectSignOut: [environment.UserAuth.oauth.redirectSignOut],
					responseType: 'code'
				}
			}
		}
	},
	Storage: {
		S3: {
			bucket: environment.Storage.aws_user_files_s3_bucket,
			region: environment.Storage.aws_user_files_s3_bucket_region
		}
	}
} as Parameters<typeof Amplify.configure>[0]);

LicenseManager.setLicenseKey(environment.agGridLicenseKey);
ModuleRegistry.registerModules([AllEnterpriseModule]);
AgChartsModuleRegistry.registerModules([AllChartsCommunityModule]);
if (environment.environmentName === 'Local' || environment.environmentName === 'Development') {
	ModuleRegistry.registerModules([ValidationModule]);
}

bootstrapApplication(App, appConfig).catch(err => console.error(err));
